import QRCodes from './QRCodes';

export default QRCodes;
